import { render, staticRenderFns } from "./MetaData.vue?vue&type=template&id=83723076&scoped=true&"
import script from "./MetaData.vue?vue&type=script&lang=js&"
export * from "./MetaData.vue?vue&type=script&lang=js&"
import style0 from "./MetaData.vue?vue&type=style&index=0&id=83723076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83723076",
  null
  
)

export default component.exports